import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import AccordionMenu from "./AccordionMenu";


const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const Slide1Content = ({ handleTutorialSlide }) => {

  return (
    <>
      <DemoPaper sx={{ my: .5, textAlign: "justify", p: 2 }} elevation={3} variant="elevation">
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          تماشای جدیدترین فیلم های دنیا با دو زیرنویس همزمان
        </Typography>
        <Typography sx={{ p: 1 }}>
          با ویژگی پخش آفلاین اوملنگ که در بالا به آن اشاره شده است شما می توانید جدید ترین فیلم های  دنیا رو به محض منتشر شدن و از هر روش که در دسترس دارید دریافت کنید و از طریق اوملنگ(umlang) به تماشای آن و یادگیری زبان از طریق آن بپردازید.
        </Typography>
        <Typography sx={{ p: 1 }}>
          مشاهده فیلم از روی سیستم و یا گوشی علاوه بر قابلیت دریافت هر چه سریع تر جدیدترین سریال ها و فیلم ها ویژگی های زیر را نیز دارد:
        </Typography>
        <Typography sx={{ p: 1 }}>
          1-  در مشاهده آنلاین فیلم شما وابستگی زیادی به سرعت اینترنت دارید که  افت سرعت باعث فریز شدن صفحه در حین تماشای فیلم و مشکلات دیگر می شود،
          اما در اوملنگ چون فیلم از روی اینترنت دانلود نمیشه به اینترنت هبچ وابستگی نداره
        </Typography>

        <Typography sx={{ p: 1 }}>
          2- دریافت فیلم از روش های گوناگون : شما میتونین فیلم یا سریال رو که دوستتون قبلا دانلود کرده بگیرین و با فلش بر روی لپ تاپ یا گوشی خودتون منتقل کنید و عملا هیچ هزینه ای بابت دانلود فیلم پرداخت نکنید
        </Typography>
        <Typography sx={{ p: 1 }}>
          اگر نیاز به دانلود دارید شما میتوانید فیلم را در زمانی که هزینه اینترنت شما کمتر می باشد (به عنوان مثال با اینترنت adsl و وای فای ، زمان طرح های تشویقی اپراتور ها ، یا طرح های شبا نت و صبا نت ) دانلود کنید و هر زمان که دوست داشتین اقدام به تماشای فیلم یادگیری زبان کنید.        </Typography>
        <Typography sx={{ p: 1 }}>
          3- امکان متوقف نمودن تماشای فیلم و از سرگیری آن در هر زمان و بدون هیچ گونه مشکل.
        </Typography>
        <Typography sx={{ p: 1 }}>
          و ...        </Typography>
        <Typography sx={{ p: 1 }}>
          یکی از مهمترین سوالاتی که زبان آموزان از ما دارند این است که می گویند ما این فلیم ها را از طریق سایت های دانلود فیلم دانلود می کنیم ولی این فیلم ها اکثرا یک زیرنویس دارند و زیرنویس دوم آن را از کجا بیاریم ، که ما برای کمک به زبان آموزان <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن </a>  مخصوص اوملنگ را راه اندازی کردیم که در ابتدای پست معرفی شد        </Typography>
        <Typography sx={{ p: 1 }}>
          <span style={{ fontWeight: "bolder" }} >پیشنهاد :</span>
          با توجه به اینکه موتور جستجوی <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن </a>  حساس به حروف است و جستجوی آن نیاز به تایپ دقیق کلمات می باشد پیشنهاد ما جستجوی نام فیلم یا سریال + عبارت اوملنگ در <a href="https://www.google.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>سایت گوگل</a>  می باشد  </Typography>
        <Typography sx={{ p: 1 }}>
          بعنوان مثال:
          زیرنویس فارسی فصل اول Friends اوملنگ  </Typography>
        <Typography sx={{ p: 1 }}>
          یا:
          لینک دانلود فیلم Oppenheimer اوملنگ  </Typography>
        <Typography sx={{ p: 1 }}>
          درصورتی که لینک مورد نظر پیدا نشد می توانید در <a href="https://forum.umlang.com" style={{ textDecoration: "none", fontWeight: "bolder" }} target={"_blank"}>انجمن اوملنگ</a> درخواست خود را ارسال کنید
        </Typography>
      </DemoPaper>
    </>
  )
}


export default Slide1Content;
